import { Injectable, Signal } from '@angular/core';
import { patchState, SignalState, signalState } from '@ngrx/signals';
import { MPKeys } from '@lentau/mpk/shared/constants';

type MPKState = {
  mpk: MPKeys;
  isInit: boolean;
};

const defaultState: MPKState = {
  mpk: MPKeys.LENTA_B2C_PICKUP,
  isInit: false,
};

@Injectable({ providedIn: 'root' })
export class MPKSignalStore {
  private readonly state: SignalState<MPKState> = signalState(defaultState);

  public readonly mpk: Signal<MPKeys> = this.state.mpk;
  public readonly isInit: Signal<boolean> = this.state.isInit;

  public initMPK(mpk: MPKeys): void {
    patchState(this.state, {
      mpk: mpk,
      isInit: true,
    });
  }

  public setMPK(mpk: MPKeys): void {
    patchState(this.state, {
      mpk: mpk,
    });
  }
}
